import styled from 'styled-components';
import { palette } from 'styled-tools';

import { FontSizes, FontWeights, minWidth, Text, TextElements, units } from '@calm-web/design-system';

import GridWrapper from '@/components/ui/GridWrapper';

export const Wrapper = styled(GridWrapper)`
	padding: ${units(7.5)} 0;
`;

export const Title = styled(Text).attrs({
	el: TextElements.H2,
})`
	&& {
		text-align: center;
		color: ${palette('buttonBlue')};
		margin-bottom: ${units(4.5)};

		${minWidth('tablet')} {
			grid-column: 1 / -1;
		}
	}
`;

export const Section = styled.div`
	&:not(:last-of-type) {
		margin-bottom: ${units(4)};
	}

	${minWidth('tablet')} {
		margin-bottom: 0;
	}
`;

export const IconWrapper = styled.div`
	width: 64px;
	height: 64px;
	margin: 0 auto;

	svg {
		height: 64px;
		width: 64px;
	}
`;

export const SectionTitle = styled(Text).attrs({
	el: TextElements.H4,
	size: FontSizes.lg,
	weight: FontWeights.Medium,
	align: 'center',
	color: 'blackAlpha80',
})`
	&& {
		margin: ${units(2)}; 0 ${units(1)};;
	}
`;

export const SectionDescription = styled(Text).attrs({
	el: TextElements.P,
	size: FontSizes.base,
	weight: FontWeights.Regular,
	align: 'center',
	color: 'blackAlpha80',
})`
	&& {
		max-width: 240px;
		margin: 0 auto;
	}
`;
